import { atom } from 'recoil';

import {
  customerConsortiumChannelsSelected,
  customerConsortiumRadioOptionSelected,
} from './constants';
import { CustomerSelection, CustomerSectionStatus, CustomerPlanSelection } from './types';

export const customerConsortiumSectionStatusState = atom<CustomerSectionStatus>({
  key: 'customerConsortiumSectionStatusState',
  default: 'opened',
});

export const customerConsortiumItemSelectedState = atom<CustomerSelection>({
  key: 'customerConsortiumItemSelectedState',
  default: { current: null, previous: null },
});

export const customerConsortiumPlanSelectedState = atom<CustomerPlanSelection | null>({
  key: 'customerConsortiumPlanSelectedState',
  default: null,
});

export const customerConsortiumChannelsSelectedState = atom({
  key: 'customerConsortiumChannelsSelectedState',
  default: customerConsortiumChannelsSelected,
});

export const customerConsortiumRadioSelectedState = atom({
  key: 'customerConsortiumRadioSelectedState',
  default: customerConsortiumRadioOptionSelected,
});
